import React from "react";
import RideForm from "../components/rides/RideForm";

const CreateRidePage = () => {
  return (
    <div>
      <h2>Créer une course</h2>
      <RideForm />
    </div>
  );
};

export default CreateRidePage;
